import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export const getChildObjectivesApi = async ({ objectiveId, timeboundDetailsId }) => {
  const url = endpoints.objective.childObjectives;
  return sendRequest({
    url,
    queryParams: {
      objectiveId,
      timeboundDetailsId,
    },
    credentials: 'include',
  });
};

export const saveObjectiveApi = ({
  objectiveTimeBound = {},
  uiKey = '',
  toIds = [],
  parentPost = null,
  type = 'OBJECTIVE',
}) => {
  const url = endpoints.objective.saveObjective;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
    body: { objectiveTimeBound, uiKey, toIds, parentPost, type },
  });
};

// objectivePId means for objective post table id.
export const getObjectiveApi = ({ objectivePId }) => {
  const url = endpoints.objective.getObjective;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'GET',
    queryParams: {
      otbPostCardId: objectivePId,
    },
  });
};

export const updateObjectiveApi = ({
  objectivePId,
  uiKey = null,
  objectiveTimeBound = {},
  toIds = [],
  parentPost = null,
  type = 'OBJECTIVE',
  renameObjective = false,
  updateAllInstances = false,
}) => {
  const url = `${endpoints.objective.saveObjective}/${objectivePId}`;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    queryParams: {
      renameObjective,
      updateAllInstances,
    },
    body: { objectiveTimeBound, uiKey, toIds, parentPost, type },
  });
};

export function getObjectiveHierarchyApi({ objectiveTimeBoundId }) {
  const url = endpoints.objective.objectiveHierarchy;
  return sendRequest({
    url,
    queryParams: {
      objectiveTimeBoundId,
    },
    credentials: 'include',
  });
}

export const getTimeBoundObjectivesApi = ({ startTS, endTS, timelineTag, tagType = 'GOAL', parentId }) => {
  const url = endpoints.objective.timePeriodObjectives;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      startTS,
      endTS,
      timelineTag,
      tagType,
      ...(parentId ? { parentId } : {}),
    },
  });
};

export const realignObjectiveApi = (queryParamsObj) => {
  const url = endpoints.objective.realignObjective;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    queryParams: queryParamsObj,
  });
};

export const deleteObjectiveApi = ({ objectiveTimeBoundId, archiveObjectiveTree = true, isDeleteRevamp = true }) => {
  const url = endpoints.objective.deleteObjective(objectiveTimeBoundId);

  return sendRequest({
    url,
    credentials: 'include',
    method: 'DELETE',
    queryParams: {
      archiveObjectiveTree,
      isDeleteRevamp,
    },
  });
};

export const cloneObjectiveApi = ({ tag, objectiveTimeBoundId, includeObjectiveTree = true }) => {
  const url = endpoints.objective.cloneObjective;
  // exclude non required keys
  const { uuid, parentTag, ...required } = tag;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
    body: { ...required },
    queryParams: {
      includeObjectiveTree,
      objectiveTimeBoundId,
    },
  });
};

export const getParentLevelVisibleForDeleteRealignApi = ({ objectiveTimeBoundId }) => {
  const url = endpoints.objective.parentLevelVisibleForDeleteRealign(objectiveTimeBoundId);
  return sendRequest({
    url,
    credentials: 'include',
  });
};
